import { autoinject, customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { watch } from 'aurelia-watch-decorator';
import { TaskMutex } from 'framework/script_utilities/task-executor';

@autoinject
@customAttribute('af-mutex-click')
export class MutexClickCustomAttribute {
  private element: HTMLButtonElement;
  @bindable({ primaryProperty: true }) clicked: Function;

  constructor(element: Element, private mutex: TaskMutex) {
    this.element = element as HTMLButtonElement;
  }

  attached() {
    this.element.classList.add(CLASS_GROUP);
    this.element.addEventListener('click', this.handleClick);
  }

  detached() {
    this.element.removeEventListener('click', this.handleClick);
    this.element.classList.remove(CLASS_GROUP, CLASS_EXECUTING, CLASS_DISABLED);
  }

  handleClick = (e: MouseEvent) => {
    e.preventDefault();
    this.clicked && this.mutex.executeIfNotRunning(() => this.styledClick());
    return false;
  }

  async styledClick() {
    try { this.element.classList.add(CLASS_EXECUTING); await this.clicked(); }
    finally { this.element.classList.remove(CLASS_EXECUTING); }
  }

  @watch((x: MutexClickCustomAttribute) => x.mutex.isRunning)
  private mutexChanged(isRunning: boolean) {
    isRunning
      ? this.element.classList.add(CLASS_DISABLED)
      : this.element.classList.remove(CLASS_DISABLED);
  }
}

export const CLASS_GROUP = 'af-mutex';
export const CLASS_EXECUTING = 'af-mutex--executing';
export const CLASS_DISABLED = 'af-mutex--disabled';
